const fetchUserInfo = async (userInfoEndpoint, accessToken, requester) => requester(userInfoEndpoint, {
    headers: { Authorization: `Bearer ${accessToken}` },
});

export { fetchUserInfo };
